import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "bg-primary-25 flex flex-col text-left justify-center px-4 text-gray-900 text-base font-medium",
    style: { "height": "52px" }
};
const _hoisted_2 = {
    style: { "height": "498px" },
    class: "overflow-y-scroll px-3 flex flex-col space-y-3"
};
const _hoisted_3 = { class: "flex flex-col py-4 space-y-3" };
const _hoisted_4 = { class: "flex flex-row space-x-2" };
const _hoisted_5 = { class: "text-sm font-medium text-gray-700" };
const _hoisted_6 = { class: "flex flex-row space-x-3 items-center" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "font-medium text-gray-400 text-xs" }, "W", -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("span", { class: "text-xs font-medium text-gray-400" }, "X", -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", { class: "font-medium text-gray-400 text-xs" }, "H", -1);
import { UIInput, UISwitch } from '@gohighlevel/ghl-ui';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AiTool',
    props: {
        width: {
            type: Number,
            require: true,
        },
        height: {
            type: Number,
            require: true,
        },
    },
    setup(__props) {
        const props = __props;
        const customizeResolution = ref(false);
        const widthInput = ref(props.width);
        const heightInput = ref(props.height);
        function enableCustomizeResolution(val) {
            customizeResolution.value = val;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('ai.title')), 1),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(_unref(UISwitch), {
                                value: customizeResolution.value,
                                size: "small",
                                "onUpdate:value": enableCustomizeResolution
                            }, null, 8, ["value"]),
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('crop.customResolution')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_unref(UIInput), {
                                size: "medium",
                                id: "image-editor-crop-width",
                                placeholder: "width",
                                value: widthInput.value,
                                "onUpdate:value": _cache[0] || (_cache[0] = ($event) => ((widthInput).value = $event)),
                                class: "w-[90px]"
                            }, {
                                suffix: _withCtx(() => [
                                    _hoisted_7
                                ]),
                                _: 1
                            }, 8, ["value"]),
                            _hoisted_8,
                            _createVNode(_unref(UIInput), {
                                size: "medium",
                                id: "image-editor-crop-height",
                                placeholder: "width",
                                value: heightInput.value,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event) => ((heightInput).value = $event)),
                                class: "w-[90px]"
                            }, {
                                suffix: _withCtx(() => [
                                    _hoisted_9
                                ]),
                                _: 1
                            }, 8, ["value"])
                        ])
                    ])
                ])
            ]));
        };
    }
});
